export const SET_TEAM = "SET_TEAM";
export const SET_TEAMS = "SET_TEAMS";
export const ADD_TEAM = "ADD_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const SET_SCHEMA_TICKET_FORM = "SET_SCHEMA_TICKET_FORM";
export const SET_FIELD_SCHEMA_TICKET_FORM = "SET_FIELD_SCHEMA_TICKET_FORM";
export const ADD_TICKET_FORM_FIELD = "ADD_TICKET_FORM_FIELD";
export const ADD_TICKET_IMPORT_FIELD = "ADD_TICKET_IMPORT_FIELD";
export const UPDATE_TICKET_FORM_FIELD = "UPDATE_TICKET_FORM_FIELD";
export const DETELE_TICKET_FORM_FIELD = "DETELE_TICKET_FORM_FIELD";
export const SET_SCHEMA_CONTACT_FORM = "SET_SCHEMA_CONTACT_FORM";
export const SET_SCHEMA_TICKET_EXPORT = "SET_SCHEMA_TICKET_EXPORT";
export const SET_SCHEMA_CONTACT_EXPORT = "SET_SCHEMA_CONTACT_EXPORT";
export const SET_SCHEMA_TICKET_FILTERS = "SET_SCHEMA_TICKET_FILTERS";
